/**
 * Minimal zlib-compatible stubs for playground browser runtime.
 */

class BaseZlibStream {
  on(): this {
    return this;
  }

  write(): void {
    // no-op
  }

  end(): void {
    // no-op
  }
}

export class Inflate extends BaseZlibStream {}
export class Deflate extends BaseZlibStream {}
export class Gunzip extends BaseZlibStream {}
export class Gzip extends BaseZlibStream {}

export const createInflate = (): Inflate => new Inflate();
export const createGunzip = (): Gunzip => new Gunzip();
export const createDeflate = (): Deflate => new Deflate();
export const createGzip = (): Gzip => new Gzip();

export const inflateSync = <T>(data: T): T => data;
export const gunzipSync = <T>(data: T): T => data;
export const deflateSync = <T>(data: T): T => data;
export const gzipSync = <T>(data: T): T => data;

type ZlibCallback<T = unknown> = (error: Error | null, result: T) => void;

const invokeCallback = <T>(data: T, callback?: ZlibCallback<T>): T => {
  if (typeof callback === 'function') {
    callback(null, data);
  }
  return data;
};

export const gzip = <T>(data: T, callback?: ZlibCallback<T>): T => invokeCallback(data, callback);
export const gunzip = <T>(data: T, callback?: ZlibCallback<T>): T => invokeCallback(data, callback);
export const inflate = <T>(data: T, callback?: ZlibCallback<T>): T => invokeCallback(data, callback);
export const deflate = <T>(data: T, callback?: ZlibCallback<T>): T => invokeCallback(data, callback);

export default {
  Inflate,
  Deflate,
  Gunzip,
  Gzip,
  createInflate,
  createGunzip,
  createDeflate,
  createGzip,
  inflateSync,
  gunzipSync,
  deflateSync,
  gzipSync,
  gzip,
  gunzip,
  inflate,
  deflate,
};
